import React, { useEffect, useState } from "react";
import { makeStyles } from "@mui/styles";
import {
  Button,
  Card,
  CardContent,
  Checkbox,
  Dialog,
  FormControlLabel,
  Grid,
  TextField,
} from "@mui/material";
import { useSelector } from "react-redux";
import { selectCareersClientValue } from "../../App/State/Slices/SelectedCareersClientSlice";
import Breadcrumb from "../../App/Components/Navigation/Breadcrumbs/Breadcrumbs";
import { getPrefilteredLink } from "./PrefilteredLinksService";
import PrefilteredLinksModal from "./Components/PrefilteredLinksModal";
import DropdownSearch from "../../App/Components/Dropdown/DropdownSearch";

function PrefilteredLinksPage() {
  const useStyles = makeStyles((theme) => ({
    root: {
      width: "50%",
      marginBottom: "50px",
      [theme.breakpoints.down("md")]: {
        width: "100%",
      },
    },
    cardContainer: {
      [theme.breakpoints.down("md")]: {
        width: "100%",
        overflowY: "scroll",
      },
      display: "flex",
      flexDirection: "column",
      marginBottom: "20px",
      width: "100%",
    },
    error: {
      color: theme.palette.error.main,
    },
    copy: {
      color: theme.palette.primary.copy,
    },
  }));

  const classes = useStyles();

  const selectCareersClient = useSelector(selectCareersClientValue);

  const [modal, setModal] = useState(false);

  const [useLocation, setUseLocation] = useState(false);
  const [onlyFeatured, setOnlyFeatured] = useState(false);
  const [trackingCode, setTrackingCode] = useState(false);
  const [remoteJobs, setRemoteJobs] = useState(false);

  const [baseUrl, setBaseUrl] = useState("");
  const [keyword, setKeyword] = useState("");
  const [geolocation, setGeolocation] = useState("");
  const [geolocationURL, setGeolocationURL] = useState("");
  const [campaign, setCampaign] = useState("");
  const [source, setSource] = useState("");
  const [medium, setMedium] = useState("");

  const [lists, setLists] = useState({});

  const [selectedIndustry, setSelectedIndustry] = useState(null);
  const [selectedFamily, setSelectedFamily] = useState(null);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [selectedCityState, setSelectedCityState] = useState(null);
  const [selectedStateCountry, setSelectedStateCountry] = useState(null);
  const [selectedCountry, setSelectedCountry] = useState(null);
  const [selectedFacility, setSelectedFacility] = useState(null);
  const [selectedFacilityName, setSelectedFacilityName] = useState(null);
  const [selectedJobType, setSelectedJobType] = useState(null);
  const [selectedjobDepartment, setSelectedJobDepartment] = useState(null);
  const [selectedBrand, setSelectedBrand] = useState(null);
  const [selectedDate, setSelectedDate] = useState(null);
  const [selectedRadius, setSelectedRadius] = useState(null);
  const [selectedFeaturedGroup, setSelectedFeaturedGroup] = useState(null);
  const [selectedFilters, setSelectedFilters] = useState([]);

  const [generatedUrls, setGeneratedUrls] = useState([]);

  const loadBingApi = () => {
    if (window.Microsoft !== undefined) {
      window.Microsoft.Maps.loadModule("Microsoft.Maps.AutoSuggest", {
        callback: onLoad,
        errorCallback: onError,
      });
      function onLoad() {
        var options = { maxResults: 5 };
        var manager = new window.Microsoft.Maps.AutosuggestManager(options);
        manager.attachAutosuggest(
          "#searchBox",
          "#searchBoxContainer",
          selectedSuggestion
        );
      }
      function onError(message) {
        console.log(message);
      }
      function selectedSuggestion(suggestionResult) {
        setGeolocationURL(
          suggestionResult.location.latitude +
            "," +
            suggestionResult.location.longitude +
            "_" +
            suggestionResult.formattedSuggestion
        );
        setGeolocation(suggestionResult.formattedSuggestion);
      }
    }
  };

  const addParameter = (url, addedFirst, key, value) => {
    var controlCharacter = addedFirst ? "&" : "?";
    url = url + controlCharacter + key + "=" + encodeURIComponent(value);
    return url;
  };

  function generateUrl() {
    var newUrl = baseUrl;
    var addedFirst = false;

    if (trackingCode && campaign === "" && source === "" && medium === "") {
      alert("All UTM codes required");
      return;
    }
    if (keyword !== "") {
      newUrl = addParameter(newUrl, addedFirst, "keyword", keyword);
      addedFirst = true;
      selectedFilters.push({ name: "Keyword", value: keyword });
    }
    if (selectedIndustry?.id !== undefined) {
      newUrl = addParameter(
        newUrl,
        addedFirst,
        "industryid",
        selectedIndustry.id
      );
      addedFirst = true;
      selectedFilters.push({ name: "Industry", value: selectedIndustry.name });
    }
    if (selectedFamily?.id !== undefined) {
      newUrl = addParameter(newUrl, addedFirst, "familyid", selectedFamily.id);
      addedFirst = true;
      selectedFilters.push({ name: "Family", value: selectedFamily.name });
    }
    if (selectedCategory?.id !== undefined) {
      newUrl = addParameter(
        newUrl,
        addedFirst,
        "categoryid",
        selectedCategory.id
      );
      addedFirst = true;
      selectedFilters.push({ name: "Category", value: selectedCategory.name });
    }
    if (selectedCityState?.item1 !== undefined) {
      newUrl = addParameter(
        newUrl,
        addedFirst,
        "citystate",
        selectedCityState.item1
      );
      addedFirst = true;
      selectedFilters.push({
        name: "City/State",
        value: selectedCityState.item1,
      });
    }
    if (selectedStateCountry?.item1 !== undefined) {
      newUrl = addParameter(
        newUrl,
        addedFirst,
        "statecountry",
        selectedStateCountry.item1
      );
      addedFirst = true;
      selectedFilters.push({
        name: "State, Country",
        value: selectedStateCountry.item1,
      });
    }
    if (selectedCountry?.item1 !== undefined) {
      newUrl = addParameter(
        newUrl,
        addedFirst,
        "countryOnly",
        selectedCountry.item1
      );
      addedFirst = true;
      selectedFilters.push({ name: "Country", value: selectedCountry.item1 });
    }
    if (selectedFacility?.item1 !== undefined) {
      newUrl = addParameter(
        newUrl,
        addedFirst,
        "facilityid",
        selectedFacility.item1
      );
      addedFirst = true;
      selectedFilters.push({ name: "Facility", value: selectedFacility.item2 });
    }
    if (selectedFacilityName?.item1 !== undefined) {
      newUrl = addParameter(
        newUrl,
        addedFirst,
        "facilityname",
        selectedFacilityName.item1
      );
      addedFirst = true;
      selectedFilters.push({
        name: "Facility Name",
        value: selectedFacilityName.item2,
      });
    }
    if (selectedJobType?.item1 !== undefined) {
      newUrl = addParameter(
        newUrl,
        addedFirst,
        "adtypeid",
        selectedJobType.item1
      );
      addedFirst = true;
      selectedFilters.push({ name: "Job Type", value: selectedJobType.item2 });
    }
    if (selectedjobDepartment?.item1 !== undefined) {
      newUrl = addParameter(
        newUrl,
        addedFirst,
        "addepartmentid",
        selectedjobDepartment.item1
      );
      addedFirst = true;
      selectedFilters.push({
        name: "Job Department",
        value: selectedjobDepartment.item2,
      });
    }
    if (selectedBrand?.item1 !== undefined) {
      newUrl = addParameter(
        newUrl,
        addedFirst,
        "brandname",
        selectedBrand.item1
      );
      addedFirst = true;
      selectedFilters.push({ name: "Brand", value: selectedBrand.item1 });
    }
    if (selectedDate?.item2 !== undefined) {
      newUrl = addParameter(
        newUrl,
        addedFirst,
        "posteddate",
        selectedDate.item2
      );
      addedFirst = true;
      selectedFilters.push({ name: "Posted Date", value: selectedDate.item2 });
    }
    if (geolocationURL !== "") {
      newUrl = addParameter(
        newUrl,
        addedFirst,
        "geolocationstring",
        geolocationURL
      );
      addedFirst = true;
      selectedFilters.push({ name: "Geolocation", value: geolocationURL });
    }
    if (selectedRadius?.item2 !== undefined) {
      newUrl = addParameter(newUrl, addedFirst, "radius", selectedRadius.item2);
      addedFirst = true;
      selectedFilters.push({ name: "Radius", value: selectedRadius.item1 });
    }
    if (useLocation) {
      newUrl = addParameter(newUrl, addedFirst, "uselocation", useLocation);
      addedFirst = true;
      selectedFilters.push({ name: "Use Location", value: "True" });
    }
    if (onlyFeatured) {
      newUrl = addParameter(newUrl, addedFirst, "featuredonly", onlyFeatured);
      addedFirst = true;
      selectedFilters.push({ name: "Featured Only", value: "True" });
    }
    if (remoteJobs) {
      newUrl = addParameter(newUrl, addedFirst, "remoteJobs", remoteJobs);
      addedFirst = true;
      selectedFilters.push({ name: "Remote Jobs", value: "True" });
    }
    if (selectedFeaturedGroup?.item1 !== undefined) {
      newUrl = addParameter(
        newUrl,
        addedFirst,
        "featuredgid",
        selectedFeaturedGroup.item1
      );
      addedFirst = true;
      selectedFilters.push({
        name: "Featured Group",
        value: selectedFeaturedGroup.item2,
      });
    }
    if (campaign !== "") {
      newUrl = addParameter(newUrl, addedFirst, "utm_campaign", campaign);
      addedFirst = true;
      selectedFilters.push({ name: "UTM Campaign", value: campaign });
    }
    if (source !== "") {
      newUrl = addParameter(newUrl, addedFirst, "utm_source", source);
      addedFirst = true;
      selectedFilters.push({ name: "UTM Source", value: source });
    }
    if (medium !== "") {
      newUrl = addParameter(newUrl, addedFirst, "utm_medium", medium);
      addedFirst = true;
      selectedFilters.push({ name: "UTM Medium", value: medium });
    }

    setGeneratedUrls([
      {
        item1: "Custom Link",
        item2: newUrl,
        item3: selectedFilters,
      },
    ]);
    setSelectedFilters([]);
    setModal(true);
  }

  function generateAll(links) {
    setGeneratedUrls(links);
    setModal(true);
  }

  useEffect(() => {
    if (geolocation === "") {
      setGeolocationURL("");
    }
  }, [geolocation]);

  useEffect(() => {
    loadBingApi();
  }, []);

  useEffect(() => {
    if (selectCareersClient !== null) {
      getPrefilteredLink(selectCareersClient.id).then((response) => {
        setBaseUrl(
          response.protocol + "://" + response.domain + "/search/searchjobs"
        );
        setLists(response);
      });
    }
  }, [selectCareersClient]);

  return (
    <>
      <div className="page-container">
        <Breadcrumb />
        <h1 className="page-title">
          {selectCareersClient.shortName} Prefiltered Links
        </h1>
        <div className={classes.root}>
          <Grid className={classes.cardContainer}>
            <Card className={classes.card}>
              <CardContent>
                <Grid container spacing={1}>
                  <Grid item xs={12} sm={12}>
                    <TextField
                      placeholder="Keyword"
                      label="Keyword"
                      variant="standard"
                      fullWidth
                      InputProps={{
                        className: classes.copy,
                      }}
                      value={keyword}
                      onChange={(e) => setKeyword(e.target.value)}
                    />
                  </Grid>
                  {lists.industriesCollection?.length > 0 ? (
                    <>
                      <Grid item xs={12} sm={6}>
                        <DropdownSearch
                          items={lists.industriesCollection}
                          property="name"
                          title="Industry"
                          handleChange={(value) => setSelectedIndustry(value)}
                        />
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <Button
                          onClick={() =>
                            generateAll(lists.industryLinksCollection)
                          }
                          variant="outlined"
                          color="primary"
                          style={{ marginTop: "10px" }}
                        >
                          Display All Industry Links
                        </Button>
                      </Grid>
                    </>
                  ) : null}
                  {lists.familiesCollection?.length > 0 ? (
                    <>
                      <Grid item xs={12} sm={6}>
                        <DropdownSearch
                          items={lists.familiesCollection}
                          property="name"
                          title="Family"
                          handleChange={(value) => setSelectedFamily(value)}
                        />
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <Button
                          onClick={() =>
                            generateAll(lists.familyLinksCollection)
                          }
                          variant="outlined"
                          color="primary"
                          style={{ marginTop: "10px" }}
                        >
                          Display All Family Links
                        </Button>
                      </Grid>
                    </>
                  ) : null}
                  {lists.categoriesCollection?.length > 0 ? (
                    <>
                      <Grid item xs={12} sm={6}>
                        <DropdownSearch
                          items={lists.categoriesCollection}
                          property="name"
                          title="Category"
                          handleChange={(value) => setSelectedCategory(value)}
                        />
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <Button
                          onClick={() =>
                            generateAll(lists.categoryLinksCollection)
                          }
                          variant="outlined"
                          color="primary"
                          style={{ marginTop: "10px" }}
                        >
                          Display All Category Links
                        </Button>
                      </Grid>
                    </>
                  ) : null}
                  {lists.cityStatesCollection?.length > 0 ? (
                    <>
                      <Grid item xs={12} sm={6}>
                        <DropdownSearch
                          items={lists.cityStatesCollection}
                          property="item2"
                          title="City/State"
                          handleChange={(value) => setSelectedCityState(value)}
                        />
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <Button
                          onClick={() =>
                            generateAll(lists.cityStateLinksCollection)
                          }
                          variant="outlined"
                          color="primary"
                          style={{ marginTop: "10px" }}
                        >
                          Display All City/State Links
                        </Button>
                      </Grid>
                    </>
                  ) : null}
                  {lists.statesCollection?.length > 0 ? (
                    <>
                      <Grid item xs={12} sm={6}>
                        <DropdownSearch
                          items={lists.statesCollection}
                          property="item2"
                          title="State, Country"
                          handleChange={(value) =>
                            setSelectedStateCountry(value)
                          }
                        />
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <Button
                          onClick={() =>
                            generateAll(lists.stateLinksCollection)
                          }
                          variant="outlined"
                          color="primary"
                          style={{ marginTop: "10px" }}
                        >
                          Display All State Links
                        </Button>
                      </Grid>
                    </>
                  ) : null}
                  {lists.countriesCollection?.length > 0 ? (
                    <>
                      <Grid item xs={12} sm={6}>
                        <DropdownSearch
                          items={lists.countriesCollection}
                          property="item2"
                          title="Country"
                          handleChange={(value) => setSelectedCountry(value)}
                        />
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <Button
                          onClick={() =>
                            generateAll(lists.countryLinksCollection)
                          }
                          variant="outlined"
                          color="primary"
                          style={{ marginTop: "10px" }}
                        >
                          Display All Country Links
                        </Button>
                      </Grid>
                    </>
                  ) : null}
                  {lists.facilitiesCollection?.length > 0 ? (
                    <>
                      <Grid item xs={12} sm={6}>
                        <DropdownSearch
                          items={lists.facilitiesCollection}
                          property="item2"
                          title="Facility"
                          handleChange={(value) => setSelectedFacility(value)}
                        />
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <Button
                          onClick={() =>
                            generateAll(lists.facilityLinksCollection)
                          }
                          variant="outlined"
                          color="primary"
                          style={{ marginTop: "10px" }}
                        >
                          Display All Facility Links
                        </Button>
                      </Grid>
                    </>
                  ) : null}
                  {lists.facilityNamesCollection?.length > 0 ? (
                    <>
                      <Grid item xs={12} sm={6}>
                        <DropdownSearch
                          items={lists.facilityNamesCollection}
                          property="item2"
                          title="Facility Name"
                          handleChange={(value) =>
                            setSelectedFacilityName(value)
                          }
                        />
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <Button
                          onClick={() =>
                            generateAll(lists.facilityNameLinksCollection)
                          }
                          variant="outlined"
                          color="primary"
                          style={{ marginTop: "10px" }}
                        >
                          Display All Facility Name Links
                        </Button>
                      </Grid>
                    </>
                  ) : null}
                  {lists.adTypesCollection?.length > 0 ? (
                    <>
                      <Grid item xs={12} sm={6}>
                        <DropdownSearch
                          items={lists.adTypesCollection}
                          property="item2"
                          title="Job Type"
                          handleChange={(value) => setSelectedJobType(value)}
                        />
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <Button
                          onClick={() =>
                            generateAll(lists.adTypeLinksCollection)
                          }
                          variant="outlined"
                          color="primary"
                          style={{ marginTop: "10px" }}
                        >
                          Display All Job Type Links
                        </Button>
                      </Grid>
                    </>
                  ) : null}
                  {lists.departmentsCollection?.length > 0 ? (
                    <>
                      <Grid item xs={12} sm={6}>
                        <DropdownSearch
                          items={lists.departmentsCollection}
                          property="item2"
                          title="Job Department"
                          handleChange={(value) =>
                            setSelectedJobDepartment(value)
                          }
                        />
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <Button
                          onClick={() =>
                            generateAll(lists.departmentLinksCollection)
                          }
                          variant="outlined"
                          color="primary"
                          style={{ marginTop: "10px" }}
                        >
                          Display All Job Department Links
                        </Button>
                      </Grid>
                    </>
                  ) : null}
                  {lists.brandsCollection?.length > 0 ? (
                    <>
                      <Grid item xs={12} sm={6}>
                        <DropdownSearch
                          items={lists.brandsCollection}
                          property="item1"
                          title="Brand"
                          handleChange={(value) => setSelectedBrand(value)}
                        />
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <Button
                          onClick={() =>
                            generateAll(lists.brandLinksCollection)
                          }
                          variant="outlined"
                          color="primary"
                          style={{ marginTop: "10px" }}
                        >
                          Display All Brand Links
                        </Button>
                      </Grid>
                    </>
                  ) : null}
                  {lists.postedDatesCollection?.length > 0 ? (
                    <Grid item xs={12} sm={12}>
                      <DropdownSearch
                        items={lists.postedDatesCollection}
                        property="item1"
                        title="Posted Date"
                        handleChange={(value) => setSelectedDate(value)}
                      />
                    </Grid>
                  ) : null}
                  <Grid item xs={12} sm={6}>
                    <div id="printoutPanel"></div>
                    <div
                      id="searchBoxContainer"
                      style={{ position: "relative" }}
                    >
                      <TextField
                        id="searchBox"
                        placeholder="Geolocation"
                        label="Geolocation"
                        variant="standard"
                        fullWidth
                        InputProps={{
                          className: classes.copy,
                        }}
                        value={geolocation}
                        onChange={(e) => setGeolocation(e.target.value)}
                      />
                    </div>
                  </Grid>
                  {lists.radiusesCollection?.length > 0 ? (
                    <Grid item xs={12} sm={6}>
                      <DropdownSearch
                        items={lists.radiusesCollection}
                        property="item1"
                        title="Radius"
                        handleChange={(value) => setSelectedRadius(value)}
                      />
                    </Grid>
                  ) : null}
                  <Grid xs={12} sm={12} item>
                    <FormControlLabel
                      className={classes.copy}
                      style={{ marginTop: "10px" }}
                      control={
                        <Checkbox
                          color="primary"
                          checked={useLocation}
                          onChange={() => setUseLocation(!useLocation)}
                        />
                      }
                      label="Use Location"
                    />
                  </Grid>
                  <Grid xs={12} sm={12} item>
                    <FormControlLabel
                      className={classes.copy}
                      style={{ marginTop: "10px" }}
                      control={
                        <Checkbox
                          color="primary"
                          checked={onlyFeatured}
                          onChange={() => setOnlyFeatured(!onlyFeatured)}
                        />
                      }
                      label="Only Featured Jobs"
                    />
                  </Grid>
                  {lists.featuredGroupsCollection?.length > 0 ? (
                    <>
                      <Grid item xs={12} sm={6}>
                        <DropdownSearch
                          items={lists.featuredGroupsCollection}
                          property="item2"
                          title="Featured Group"
                          handleChange={(value) =>
                            setSelectedFeaturedGroup(value)
                          }
                        />
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <Button
                          onClick={() =>
                            generateAll(lists.featuredGroupLinksCollection)
                          }
                          variant="outlined"
                          color="primary"
                          style={{ marginTop: "10px" }}
                        >
                          Display All Featured Group Links
                        </Button>
                      </Grid>
                    </>
                  ) : null}
                  <Grid xs={12} sm={12} item>
                    <FormControlLabel
                      className={classes.copy}
                      style={{ marginTop: "10px" }}
                      control={
                        <Checkbox
                          color="primary"
                          checked={trackingCode}
                          onChange={() => setTrackingCode(!trackingCode)}
                        />
                      }
                      label="Include Tracking Code"
                    />
                  </Grid>
                  <Grid xs={12} sm={12} item>
                    <FormControlLabel
                      className={classes.copy}
                      style={{ marginTop: "10px" }}
                      control={
                        <Checkbox
                          color="primary"
                          checked={remoteJobs}
                          onChange={() => setRemoteJobs(!remoteJobs)}
                        />
                      }
                      label="Remote Jobs"
                    />
                  </Grid>
                  <Grid item xs={12} sm={4}>
                    <TextField
                      placeholder="UTM Campaign"
                      label="UTM Campaign"
                      variant="standard"
                      fullWidth
                      InputProps={{
                        className: classes.copy,
                      }}
                      value={campaign}
                      onChange={(e) => setCampaign(e.target.value)}
                    />
                  </Grid>
                  <Grid item xs={12} sm={4}>
                    <TextField
                      placeholder="UTM Source"
                      label="UTM Source"
                      variant="standard"
                      fullWidth
                      InputProps={{
                        className: classes.copy,
                      }}
                      value={source}
                      onChange={(e) => setSource(e.target.value)}
                    />
                  </Grid>
                  <Grid item xs={12} sm={4}>
                    <TextField
                      placeholder="UTM Medium"
                      label="UTM Medium"
                      variant="standard"
                      fullWidth
                      InputProps={{
                        className: classes.copy,
                      }}
                      value={medium}
                      onChange={(e) => setMedium(e.target.value)}
                    />
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    sm={12}
                    container
                    justifyContent="flex-end"
                  >
                    <Button
                      style={{ marginTop: "20px", marginRight: "8px" }}
                      className={classes.sensitiveButton}
                      type="submit"
                      variant="contained"
                      color="primary"
                      onClick={() => generateUrl()}
                    >
                      Generate Link
                    </Button>
                  </Grid>
                </Grid>
              </CardContent>
            </Card>
          </Grid>
        </div>
      </div>
      <Dialog
        open={modal}
        fullWidth={true}
        maxWidth="md"
        onClose={() => setModal(false)}
      >
        <PrefilteredLinksModal openModal={setModal} links={generatedUrls} />
      </Dialog>
    </>
  );
}

export default PrefilteredLinksPage;
